import api from './api'
import type { GateId, MilestoneKey, MilestoneState } from '@/types/milestones'

export type ProfileUserInfo = {
  id?: number
  UserName?: string
  TheNameOfUser?: string
  Department?: { DepartmentName?: string } | null
  total_Points?: number
  Mony_amount?: number
}

export type ProfileSettings = {
  language?: string
  email_notifications?: boolean
  push_notifications?: boolean
  weekly_digest?: boolean
  show_all_features?: boolean
}

export const profileService = {
  async getUserInfo(): Promise<ProfileUserInfo | null> {
    try {
      const res = await api.get<{ success?: boolean; user?: ProfileUserInfo } & ProfileUserInfo>('/api/v1/profile/user_info')
      return res.data?.user ?? res.data ?? null
    } catch {
      return null
    }
  },

  async getSettings(): Promise<ProfileSettings | null> {
    const res = await api.get<{ success?: boolean; data?: ProfileSettings }>('/api/v1/profile/settings')
    return res.data?.data ?? null
  },

  async updateSettings(settings: ProfileSettings): Promise<void> {
    await api.put('/api/v1/profile/settings', settings)
  },

  async registerPushToken(token: string): Promise<void> {
    await api.put('/api/v1/profile/push-token', { token })
  },

  async unregisterPushToken(token?: string): Promise<void> {
    await api.delete('/api/v1/profile/push-token', { data: token ? { token } : {} })
  },

  async getMilestones(): Promise<MilestoneState | null> {
    try {
      const res = await api.get<{ success?: boolean; data?: MilestoneState }>(
        '/api/v1/profile/milestones',
      )
      return res.data?.data ?? null
    } catch {
      return null
    }
  },

  async ackMilestone(key: MilestoneKey): Promise<void> {
    await api.post(`/api/v1/profile/milestones/${key}/ack`)
  },

  async getNavigationGates(): Promise<Partial<Record<GateId, boolean>> | null> {
    try {
      const res = await api.get<{
        success?: boolean
        data?: { gates?: Partial<Record<GateId, boolean>> }
      }>('/api/v1/profile/navigation-gates')
      return res.data?.data?.gates ?? null
    } catch {
      return null
    }
  },
}
